'use strict';

var FaresOptimizerAnalysisRecommendationGridsDirective = function FaresOptimizerAnalysisRecommendationGridsDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'FaresOptimizerAnalysisFiltersController',
    template: require('../templates/fares-optimizer-analysis-filters.html'),
    scope: {
      screenState: '=',
      searchCriteria: '='
    }
  };
};
FaresOptimizerAnalysisRecommendationGridsDirective.$inject = [];
module.exports = FaresOptimizerAnalysisRecommendationGridsDirective;